import { Outlet } from 'react-router-dom';
import { Appbar } from '../../design-system';
import { DashboardBase } from './DashboardComponents';

export const Dashboard = () => {
  return (
    <DashboardBase id={'dashboard'}>
      <Appbar />
      <Outlet />
    </DashboardBase>
  );
};
